// RxJS v6+
import moment from 'moment'
import { fromEvent, interval } from 'rxjs'
import { debounce } from 'rxjs/operators'

(() => {
    if (PRODUCTION) {
        return
    }

    document.body.style.backgroundColor = 'black'

    let token = localStorage.getItem('token') || ''
    console.debug(`token: ${token.substring(0, 4)}...${token.substring(token.length - 4)}`)

    let renderPlaceHolder = localStorage.getItem('debug') ||
        `render({
    date:        "${moment(new Date()).format('YYYY/MM/DD')}",                // { now, 2020/week/1, 2020[/02/26/22] } 
    startMonth:  "5",
    environment: "apps",                      // { apps, ios_widget_small, ios_widget_medium, ios_widget_large } 
    lang:        "nl",                        // { nl, en }                                          optional
    type:        "main_connection",           // { main_connection, solar, home_usage, gas, ...}     optional
    timezone:    "Europe/Amsterdam",          //                                                     optional
    flag:        ["_three_phases"],
    fullscreen:  true,                        // { true / false }
    devices: [
        // { "identifier": "p1dongle/3c39e...", "measurementType": "main_connection" },          // My super awesome P1 dongle
        // { "identifier": "energysocket/3c39e...", "measurementType": "computer" },      // My Super-duper-dolka-polka-poly-gizmo socket
        // { "identifier": "energymeter/3c39e...", "measurementType": "solar" },       // My Mega Mega energymeter, superb! =/
    ],   
    token:      token,
})`

    // Workaround: when set to 100% the chart container does not resize correctly when window height decreases
    document.getElementById('chart-container').style.height = '99%'

    const container = document.createElement('div')
    container.style.padding = '1em'
    container.setAttribute('id', 'debug-container')
    container.setAttribute('class', 'debug')

    document.getElementById('box').appendChild(container)
    const textArea = document.createElement('textarea')
    const loginForm = document.createElement('form')

    const loginFormHtml = `
        <input id="user" class="dark" type="text" placeholder="HW account" name="user" autocomplete="username" required>
        <input id="pass" class="dark" type="password" placeholder="password" name="pass" autocomplete="current-password" required>
    
        <button class="dark" type="submit">Login</button>
    `

    textArea.setAttribute('id', 'debug')
    textArea.innerHTML = renderPlaceHolder
    textArea.style.width = '100%'
    textArea.style.height = '325px'
    textArea.style['font-size'] = '1em'
    textArea.style['line-height'] = '1.5em'
    textArea.setAttribute('class', 'dark')

    loginForm.setAttribute('method', 'post')
    loginForm.setAttribute('action', '/')
    loginForm.innerHTML = loginFormHtml

    container.appendChild(loginForm)
    container.appendChild(textArea)

    const evalTextArea = () => {
        try {
            eval(textArea.value)
            // save to local storage
            localStorage.setItem('debug', textArea.value)
        } catch (err) {
            console.error({
                msg: 'could not render',
                err: err
            })
        }
    }

    fromEvent(loginForm, 'submit')
        .subscribe(async (evt) => {
            evt.preventDefault()
            let user = document.getElementById("user").value
            let pass = document.getElementById("pass").value;

            const response = await fetch('login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    user: user,
                    pass: pass
                })
            })

            if (response.status === 200) {
                ({token} = await response.json())
                localStorage.setItem('token', token)
                console.log('Logged in')
            } else {
                console.error(await response.text())
            }
        })

    fromEvent(document, 'DOMContentLoaded').subscribe(evalTextArea)

    fromEvent(textArea, 'keyup')
        .pipe(
            debounce(() => interval(350))
        )
        .subscribe((evt) => {
            evalTextArea()
        })
})()